angular.module('tgaApp').controller('FlashController', [
  '$scope',
  '$rootScope',
  '$timeout',
  'flashService',
  function ($scope, $rootScope, $timeout, flashService) {
    $scope.data = {
      alerts: [],
    };

    const stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', () => {
      if ($scope.timer) {
        $timeout.cancel($scope.timer);
      }

      $scope.data.alerts = flashService.get();

      $scope.timer = $timeout(() => {
        $scope.data.alerts.splice($scope.data.alerts.length - 1, 1);
      }, 5000);
    });

    $scope.$on('$destroy', () => {
      stateChangeSuccess();
    });
  },
]);
